import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const getBadgeColorClass = (type: string): string => {
  switch (type) {
    case 'factory':
      return 'bg-warning text-dark';
    case 'dev':
      return 'bg-purple';
    case 'beta':
      return 'bg-warning';
    case 'prod':
      return 'bg-success';
    case 'depr':
      return 'bg-danger';
    default:
      return 'bg-secondary';
  }
};

interface AllReleasesModalProps {
  show: boolean;
  onClose: () => void;
  releases: any[];
  model: string;
  onUpdateRelease: (model: string, index: number, field: string, value: any) => void;
  allReleases: any[];
}

const AllReleasesModal: React.FC<AllReleasesModalProps> = ({
  show,
  onClose,
  releases,
  model,
  onUpdateRelease,
  allReleases
}) => {
  if (!show) {
    return null;
  }

  const isAddedToChangelog = (release: any): boolean => {
    if (typeof release.addToChangelog === 'boolean') {
      return release.addToChangelog;
    }
    return release.type === 'prod' || release.type === 'depr';
  };

  const updateRelease = (release: any, field: string, value: any) => {
    const originalIndex = allReleases.findIndex(r => r._id === release._id);
    if (originalIndex !== -1) {
      onUpdateRelease(model, originalIndex, field, value);
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div className="modal fade show" style={{ display: 'block' }} tabIndex={-1} role="dialog">
        <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">All Releases - {model}</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {releases.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>Version</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Deployment</th>
                        <th>Add to Changelog</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {releases.map((release, index) => (
                        <tr key={index}>
                          <td>
                            v{release.version}
                            {(release.type === 'dev' || release.type === 'alpha') && release.label && (
                              <span className="badge ms-2" style={{ backgroundColor: '#e9ecef', color: '#495057' }} title="Build label">
                                {release.label}
                              </span>
                            )}
                          </td>
                          <td>
                            <span className={`badge ${getBadgeColorClass(release.type)}`}>
                              {release.type}
                            </span>
                          </td>
                          <td>
                            <span className={`badge ${release.enabled ? 'bg-success' : 'bg-danger'}`}>
                              {release.enabled ? 'Enabled' : 'Disabled'}
                            </span>
                          </td>
                          <td>
                            <select 
                              className="form-select form-select-sm"
                              value={release.type}
                              onChange={(e) => updateRelease(release, 'type', e.target.value)}
                            >
                              <option value="dev">Development</option>
                              <option value="beta">Beta</option>
                              <option value="prod">Production</option>
                              <option value="depr">Deprecated</option>
                              <option value="factory">Factory</option>
                            </select>
                          </td>
                          <td>
                            <div className="form-check form-switch mb-0">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                checked={isAddedToChangelog(release)}
                                onChange={(e) => updateRelease(release, 'addToChangelog', e.target.checked)}
                                aria-label={`Add v${release.version} to changelog`}
                              />
                            </div>
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => updateRelease(release, 'delete', true)}
                              title="Delete Release"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="alert alert-info">
                  No releases found for this model.
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllReleasesModal; 